import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/login.vue'
import HomePage from '../views/index.vue'
import CategoryPage from '../views/category.vue'
import TprPage from '../views/tpr.vue'
import FlashPage from '../views/flash.vue'
import WordPage from '../views/word.vue'
import TprFullscreenPage from '../views/tpr-fullscreen.vue'
import FullscreenPage from '../views/fullscreen.vue'
import VideosPage from '../views/videos.vue'
import AudioPage from '../views/audio.vue'
import SeriesPage from '../views/series.vue'
import PlayPage from '../views/play.vue'
import ActivatePage from '../views/activate.vue'
import VipPage from '../views/vip.vue'
import HistoryPage from '../views/history.vue'
import ParentalPage from '../views/parental.vue'
import PreferencePage from '../views/preference.vue'

const AUTH_STORAGE_KEY = 'tree-sprout-auth'
const PARENT_VERIFIED_STORAGE_KEY = 'tree-sprout-parent-verified'
const PUBLIC_PATHS = ['/', '/activate']

const routes = [
  { path: '/', component: LoginPage },
  { path: '/home', component: HomePage },
  { path: '/category', component: CategoryPage },
  { path: '/tpr', component: TprPage },
  { path: '/flash', component: FlashPage },
  { path: '/word', component: WordPage },
  { path: '/tpr-fullscreen', component: TprFullscreenPage },
  { path: '/fullscreen', component: FullscreenPage },
  { path: '/videos', component: VideosPage },
  { path: '/audio', component: AudioPage },
  { path: '/series', component: SeriesPage },
  { path: '/play', component: PlayPage },
  { path: '/activate', component: ActivatePage },
  { path: '/vip', component: VipPage },
  { path: '/history', component: HistoryPage },
  { path: '/parental', component: ParentalPage },
  { path: '/preference', component: PreferencePage }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const isAuthenticated = window.localStorage.getItem(AUTH_STORAGE_KEY) === '1'

  if (!PUBLIC_PATHS.includes(to.path) && !isAuthenticated) {
    return '/'
  }

  if (to.path === '/' && isAuthenticated) {
    return '/home'
  }

  if (to.path === '/parental' && window.sessionStorage.getItem(PARENT_VERIFIED_STORAGE_KEY) !== '1') {
    return '/home'
  }

  return true
})

export default router
